import productImg from "../../../assets/img/product-gg-6-free-shipping.png";
import productImgWebp from "../../../assets/img/product-gg-6-free-shipping.webp";
import cardsImg from "../../../assets/img/cards.png";
import cardsImgWebp from "../../../assets/img/cards.webp";

const Offer = () => (
    <section id="offer">
        <div className="container-fluid gg-bg-solid-blue text-white">
            <div className="row justify-content-center align-content-center text-center py-3 gg-bg-solid-yellow-light text-black">
                <div className="col-11">
                    <h1 className="fw-bold">That’s Why We’re Giving You This One-Time Upgrade Opportunity:</h1>
                </div>
            </div>
            <div className="row justify-content-center align-content-center pt-5">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-border-radius">
                    <div className="row justify-content-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-content-center text-center">
                            <h1 className="gg-text-highlight-green mb-2">SAVE $858</h1>
                            <picture>
                                <source srcSet={productImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={productImg} loading="lazy" />
                            </picture>
                            <h3 className="mt-5">
                                <span className="text-uppercase">6 Bottles </span>
                                <span className="text-white-50 text-uppercase">for just</span>
                            </h3>
                            <h3>
                                <s className="text-white-50">$1074</s>
                                <span className="text-uppercase ms-1">$216</span>
                            </h3>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-md-start text-center align-content-center">
                            <h2 className="mt-lg-4 mb-5"><b>Upgrade now and add your 6-Month Supply </b></h2>
                            <h3 className="mt-lg-4 mb-5">For Just <s>$179</s> <b>$36 Per Bottle</b> — the lowest price we’ve ever offered… and ever will.</h3>
                            <h2 className="fw-bold mb-5">Includes Free US Shipping</h2>
                            <h2 className="fw-bold">Lock in the biggest discount while it’s still available!</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center text-center">
                <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-7 col-10 ">
                    <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu6u&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-decoration-none btn gg-button-buy-yellow gg-buy-card-button gg-bigger-button fw-bold text-uppercase gtm-buy-btn" data-gtm-label="GlucoGen Upsell 6 - Offer - Yes Button" data-gtm-product="glu6u" data-gtm-price="216">GET YOUR 6-MONTH SUPPLY NOW</a>
                </div>
            </div>
            <div className="row justify-content-center text-center mt-4 pb-5">
                <div className="col-xxl-6 col-xl-7 col-lg-8 col-sm-10">
                    <div className="mb-5">
                        <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu6u&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-white gtm-buy-btn" data-gtm-label="GlucoGen Upsell 6 - Offer - Yes Link" data-gtm-product="glu6u" data-gtm-price="216">Yes, I'd like to add an additional 6 bottles. Please upgrade my order now and apply the biggest discount.</a>
                    </div>
                    <a href="/bg/ud/glucogen-d-3" className="text-white-50 gg-small-text gg-link gtm-no-ud-btn" data-gtm-label="GlucoGen Upsell 6 - Offer - No Link" data-gtm-product="glu6u" data-gtm-price="216">No Thanks, I’ll Miss This Unique Offer. I Understand That This Is A One-Time-Only Discount And Will No Longer Be Available Later.</a>
                    <div className="mt-4">
                        <picture>
                            <source srcSet={cardsImgWebp} type="image/webp" />
                            <img className="img-fluid gg-cards-max-height" src={cardsImg} loading="lazy" />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Offer;